jQuery(document).ready(function($) {
    jQuery.each(jQuery('.menu-item').has('div.sub-menu'), function() {
        jQuery(this).addClass('dropdown');
        $(this).find('>a').addClass("dropdown-toggle");

    });

    jQuery('#menu-primary-menu .dropdown-toggle').on('click', function() {
        var location = jQuery(this).attr('href');
        console.log(location);
        window.location.href = location;
        return false;
    });

    let filterBlock = $('#filter_block');
    let loader = $('#SpinLoader');
    let ajaxURL = getAdminUrl("/admin-ajax.php");

    $('.dropdown-time .time-item').on('click', function() {
        filterBlock.hide();
        loader.show();
        let filterVal = $(this).attr('data-dropDown-val');
        let btn = $(this).closest('.dropdown').find('.dropdown-toggle');
        let btnw = $('.dropdown-workshop .workshop-item').closest('.dropdown').find('.dropdown-toggle');
        let keyword = $('#key-search').val();
        let workshop_cat = $('.dropdown-workhop .workshop-item').attr('data-dropDown-val') != 'select' ? $('.dropdown-workshop .workshop-item').attr('data-dropDown-val') : 'all';

        if (filterVal == "reset") {
            filterBlock.hide();
            loader.show();
            location.reload();
        } else {
            let termId = btn.attr('data-termId');
            let showsId = btn.attr('shows_id');
            btn.text($(this).text());
            btnw.text('Select');
            let workshopId = btn.attr('data-cat_id');
            let ajaxURL = getAdminUrl("/admin-ajax.php");
            let data = {
                'action': 'filter_schedules_by_ajax',
                'filterVal': filterVal,
                'id': termId,
                'slug': getAllUrlParams(window.location.search).hasOwnProperty('slug') ? '1' : '',
                'workshop_cat': workshop_cat,
                'cat_id': workshopId,
                'shows_id': showsId,
                'keyword': keyword
            };

            $.ajax({
                url: ajaxURL,
                type: "POST",
                data: data
            }).done(function(response) {
                filterBlock.html(response);
                filterBlock.show();
                loader.hide();
            });
        }
    });
    $('.dropdown-workshop .workshop-item').on('click', function() {
        filterBlock.hide();
        loader.show();
        let filterVal = $('.dropdown-time .time-item').attr('data-dropDown-val') != 'reset' ? $('.dropdown-time .time-item').attr('data-dropDown-val') : 'all';
        let btn = $('.dropdown-time .time-item').closest('.dropdown').find('.dropdown-toggle');
        let workshop_cat = $(this).attr('data-dropDown-val');
        let btnw = $(this).closest('.dropdown').find('.dropdown-toggle');
        let keyword = $('#key-search').val();

        if (workshop_cat == "select") {
            filterBlock.hide();
            loader.show();
            location.reload();
        } else {
            let showsId = btn.attr('shows_id');
            let termId = btn.attr('data-termId');
            let workshopId = btnw.attr('data-cat_id');
            // btnw.text($(this).text());
            btnw.empty();
            btnw.append($(this).html());
            btn.text('All');
            let ajaxURL = getAdminUrl("/admin-ajax.php");
            let data = {
                'action': 'filter_schedules_by_ajax',
                'filterVal': filterVal,
                'id': termId,
                'slug': getAllUrlParams(window.location.search).hasOwnProperty('slug') ? '1' : '',
                'workshop_cat': workshop_cat,
                'cat_id': workshopId,
                'shows_id': showsId,
                'keyword': keyword
            };

            $.ajax({
                url: ajaxURL,
                type: "POST",
                data: data
            }).done(function(response) {
                filterBlock.html(response);
                filterBlock.show();
                loader.hide();
            });
        }
    });
    $(".time-search").click(function() {
        click_search();
    });

    function click_search() {
        filterBlock.hide();
        loader.show();
        let filterVal = $('.dropdown-time .time-item').attr('data-dropDown-val') != 'reset' ? $('.dropdown-time .time-item').attr('data-dropDown-val') : 'all';
        let workshop_cat = $('.dropdown-workshop .workshop-item').attr('data-dropDown-val') != 'select' ? $('.dropdown-workshop .workshop-item').attr('data-dropDown-val') : 'all';
        let btn = $('.dropdown-time .time-item').closest('.dropdown').find('.dropdown-toggle');
        let keyword = $('#key-search').val();
        let termId = btn.attr('data-termId');
        let showsId = btn.attr('shows_id');
        let workshopId = btn.attr('data-cat_id');
        let ajaxURL = getAdminUrl("/admin-ajax.php");
        let data = {
            'action': 'filter_schedules_by_ajax',
            'filterVal': filterVal,
            'id': termId,
            'slug': getAllUrlParams(window.location.search).hasOwnProperty('slug') ? '1' : '',
            'workshop_cat': workshop_cat,
            'cat_id': workshopId,
            'shows_id': showsId,
            'keyword': keyword
        };
        $.ajax({
            url: ajaxURL,
            type: "POST",
            data: data
        }).done(function(response) {
            filterBlock.html(response);
            filterBlock.show();
            loader.hide();
        });
    }
    var input = document.getElementById("key-search");
    if (input) {
        input.addEventListener("keyup", function(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                click_search();
            }
        });
    }

    $('.double-column .showMoreToggle').on('click', function (e) {
        e.preventDefault();

        $(this).text(function(i, text) {
            return text === 'Show More' ? 'Show Less' : 'Show More';
        });

        $('.double-column .moreContent').slideToggle();
    });
});

$ = jQuery;
$(document).ready(function() {
    $(document).on('click', '.partner__list a[href^="#"]', function(event) {
        event.preventDefault();
        // alert();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 150
        }, 600);
    });

    $(document).on('click', '.resources-exhibit__nav a[href^="#"]', function(event) {
        event.preventDefault();
        // alert();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 150
        }, 600);
    });

    $('.site-header__top .navbar .dropdown').hover(function() {
        $(this).find('.dropdown-menu').first().stop(true, true).delay(250).slideDown();
    }, function() {
        $(this).find('.dropdown-menu').first().stop(true, true).delay(100).slideUp();
    });
    $('.navbar .dropdown > a').click(function() {
        location.href = this.href;
    });

    $(".resources-exhibit__text .dropdown-menu a").click(function(e) {
        e.preventDefault();
        $(this).parents(".dropdown").find('.select-btn').text($(this).text());
        $(this).parents(".dropdown").find('.select-btn').attr("data_attr", $(this).attr("data_attr"));
        var red_lk = $(this).attr("data_attr");
        $(this).closest(".btn-wrap").find(".redirect_btn").attr("href", red_lk);


    });

    jQuery('.toggle-btn').click(function() {
        jQuery('.silder-modal').toggleClass('slide-out');
    });

    jQuery(document).on('gform_confirmation_loaded', function(event, formId) {
        if (formId == 2) {
            $(window).scrollTop($('#speaker-submission').offset().top);
        }
    });

    try {
        if ($("#attendee-testimonials #v-pills-tab.card-deck").length > 0) {
            $("#attendee-testimonials #v-pills-tab").slick({
                infinite: false,
                asNavFor: '#ss_gallery_slick',
                arrows: false,
                slidesToShow: 3,
                focusOnSelect: true
            });
        }

        if ($('#ss_gallery_slick').length > 0) {
            $('#ss_gallery_slick').slick({
                dots: false,
                infinite: true,
                speed: 500,
                cssEase: 'linear',
                arrows: false,
                fade: true,
                slidesToShow: 1,
                asNavFor: '#attendee-testimonials #v-pills-tab.card-deck'
            });
        }
    } catch (err) {
        //console.log(err);
    }
});
$(window).on("load", function() {
    var urlHash = window.location.href.split("#")[1];
    let sreenWidth = (window.innerWidth || document.documentElement.clientWidth);
    if (urlHash == 'schedule') {
        if (sreenWidth <= 421) {
            offsetData = -(160);
        } else {
            var offsetData = 20;
        }
    } else if (urlHash == 'tour') {
        if (sreenWidth <= 421) {
            offsetData = -(270);
        } else {
            var offsetData = -95;
        }
    } else if (urlHash == 'thank-you') {
        if (sreenWidth > 767 && sreenWidth <= 1536) {
            offsetData = -15;
        } else if (sreenWidth <= 767) {
            offsetData = 35;
        } else {
            offsetData = -30;
        }
    } else {
        var offsetData = 0;
    }
    if (urlHash) {
        $('html,body').animate({
            scrollTop: $('#' + urlHash).offset().top - offsetData
        }, 4000);
    }

    jQuery('.silder-modal').toggleClass('slide-out');

});

// Print popup
function myFunction() {
    window.print();
}

var hash = window.location.hash;
//alert(hash)
var testiatag = $(".testimonial-video__nav ul li a");
var testicontdiv = $(".testimonial-video__content .tab-content div");

if (hash == '#exhibitors') {
    testiatag.removeClass("active");
    testicontdiv.removeClass("show active");
    $(".testimonial-video__nav ul li:nth-child(2) a").addClass("active");
    $(".testimonial-video__content .tab-content div:nth-child(2)").addClass("show active");
} else if (hash == '#attendees') {
    testiatag.removeClass("active");
    testicontdiv.removeClass("show active");
    $(".testimonial-video__nav ul li:nth-child(1) a").addClass("active");
    $(".testimonial-video__content .tab-content div:nth-child(1)").addClass("show active");
} else if (hash == '#gallery') {
    testiatag.removeClass("active");
    testicontdiv.removeClass("show active");
    $(".testimonial-video__nav ul li:nth-child(3) a").addClass("active");
    $(".testimonial-video__content .tab-content div:nth-child(3)").addClass("show active");
}

$('body').on('click', '.testimonial-video__nav .nav-link', function() {
    window.location.hash = $(this).attr("data-id");
});


jQuery('.sponsors__type').each(function() {

    var requiredChilds = jQuery(this).find('li');
    if (requiredChilds.length == 0)
        jQuery(this).hide();
    var levels = jQuery(this).attr('data-attr');
    if (levels == "PLATINUM" || levels == "GOLD" || levels == "SILVER" || levels == "PARTNERS" || levels == "#SMALLBIZ EXPO" || levels == "MEDIA PARTNERS" || levels == "NATIONAL PRESENTING") {
        if (requiredChilds.length < 5) {
            jQuery(requiredChilds).css({
                'flex-basis': '25%',
                'max-width': '25%',
            });
        }
        if (requiredChilds.length > 5 && requiredChilds.length < 11) {
            if (requiredChilds.length % 2 == 0) {
                maxWidth = Math.floor(requiredChilds.length / 2);
                divMaxWidth = 100 / maxWidth;
                breakList(maxWidth, requiredChilds);
            } else {
                maxWidth = Math.floor(requiredChilds.length / 2) + 1;
                divMaxWidth = 100 / maxWidth;
                // jQuery('.sponsors__type ul li').flex(100/divMaxWidth+'%');
                breakList(maxWidth, requiredChilds);
            }
        }
        if (requiredChilds.length >= 11 && requiredChilds.length < 16) {
            if (requiredChilds.length % 2 == 0) {
                maxWidth = Math.floor(requiredChilds.length / 3);
                divMaxWidth = 100 / maxWidth;
                breakList(maxWidth, requiredChilds);
            } else {
                maxWidth = Math.floor(requiredChilds.length / 3) + 1;
                divMaxWidth = 100 / maxWidth;
                breakList(maxWidth, requiredChilds);
            }
        }

        if (requiredChilds.length >= 15 && requiredChilds.length < 21) {
            if (requiredChilds.length % 2 == 0) {
                maxWidth = Math.floor(requiredChilds.length / 4);
                divMaxWidth = 100 / maxWidth;
                breakList(maxWidth, requiredChilds);
            } else {
                maxWidth = Math.floor(requiredChilds.length / 4) + 1;
                divMaxWidth = 100 / maxWidth;
                breakList(maxWidth, requiredChilds);
            }
        }
    } else {
        if (requiredChilds.length < 5) {
            jQuery(requiredChilds).css({
                'flex-basis': '25%',
                'max-width': '25%',
            });
        }
        if (requiredChilds.length > 4 && requiredChilds.length < 9) {
            if (requiredChilds.length % 2 == 0) {
                maxWidth = Math.floor(requiredChilds.length / 2);
                divMaxWidth = 100 / maxWidth;
                goldBreakList(maxWidth, requiredChilds);
            } else {
                maxWidth = Math.floor(requiredChilds.length / 2) + 1;
                divMaxWidth = 100 / maxWidth;
                goldBreakList(maxWidth, requiredChilds);
            }
        }
        if (requiredChilds.length >= 9 && requiredChilds.length < 13) {
            if (requiredChilds.length % 3 == 0) {
                maxWidth = Math.floor(requiredChilds.length / 3);
                divMaxWidth = 100 / maxWidth;
                goldBreakList(maxWidth, requiredChilds);
            } else {
                maxWidth = Math.floor(requiredChilds.length / 3) + 1;
                divMaxWidth = 100 / maxWidth;
                goldBreakList(maxWidth, requiredChilds);

            }
        }
    }
});

function getAdminUrl(path) {
    var $body = jQuery('body[data-admin_url]');
    return ($body.length ? $body.data('admin_url') : '/wp-admin/') + (path ? path : '');
}

function getAllUrlParams(url) {

    // get query string from url (optional) or window
    var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

    // we'll store the parameters here
    var obj = {};

    // if query string exists
    if (queryString) {

        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];

        // split our query string into its component parts
        var arr = queryString.split('&');

        for (var i = 0; i < arr.length; i++) {
            // separate the keys and the values
            var a = arr[i].split('=');

            // set parameter name and value (use 'true' if empty)
            var paramName = a[0];
            var paramValue = typeof(a[1]) === 'undefined' ? true : a[1];

            // (optional) keep case consistent
            paramName = paramName.toLowerCase();
            if (typeof paramValue === 'string')
                paramValue = paramValue.toLowerCase();

            // if the paramName ends with square brackets, e.g. colors[] or colors[2]
            if (paramName.match(/\[(\d+)?\]$/)) {

                // create key if it doesn't exist
                var key = paramName.replace(/\[(\d+)?\]/, '');
                if (!obj[key])
                    obj[key] = [];

                // if it's an indexed array e.g. colors[2]
                if (paramName.match(/\[\d+\]$/)) {
                    // get the index value and add the entry at the appropriate position
                    var index = /\[(\d+)\]/.exec(paramName)[1];
                    obj[key][index] = paramValue;
                } else {
                    // otherwise add the value to the end of the array
                    obj[key].push(paramValue);
                }
            } else {
                // we're dealing with a string
                if (!obj[paramName]) {
                    // if it doesn't exist, create property
                    obj[paramName] = paramValue;
                } else if (obj[paramName] && typeof obj[paramName] === 'string') {
                    // if property does exist and it's a string, convert it to an array
                    obj[paramName] = [obj[paramName]];
                    obj[paramName].push(paramValue);
                } else {
                    // otherwise add the property
                    obj[paramName].push(paramValue);
                }
            }
        }
    }

    return obj;
}

function breakList(maxWidth, list) {
    var lineBreak = '<span class="d-lg-block d-none w-100"></span>'
    jQuery(lineBreak).insertAfter(list[maxWidth - 1]);
    jQuery(lineBreak).insertAfter(list[2 * maxWidth - 1]);
    jQuery(lineBreak).insertAfter(list[3 * maxWidth - 1]);
    jQuery(lineBreak).insertAfter(list[4 * maxWidth - 1]);

    jQuery(list).css({
        'flex-basis': '20%',
        'max-width': '20%',
    });

}

function goldBreakList(maxWidth, list) {
    var lineBreak = '<span class="d-lg-block d-none w-100"></span>'
    jQuery(lineBreak).insertAfter(list[maxWidth - 1]);
    jQuery(lineBreak).insertAfter(list[2 * maxWidth - 1]);
    jQuery(lineBreak).insertAfter(list[3 * maxWidth - 1]);
    jQuery(lineBreak).insertAfter(list[4 * maxWidth - 1]);

    jQuery(list).css({
        'flex-basis': '25%',
        'max-width': '25%',
    });

}
// popup for the modal
jQuery(function() {
    var myurl = window.location.href;
    var querystring = window.location.search;
    var urlparam = new URLSearchParams(querystring);


    if (myurl.match(/city/) && urlparam.get('share') == 1) {
        // submitData();
        jQuery("#thankyou__modal").modal();
    }

    //     jQuery("#thankyou__modal").on('hide.bs.modal', function(){
    //         thankyou();
    // });
    jQuery(".facebook-icon, .twitter-icon, .linkedin-icon, .envelope-icon").click(function() {
        jQuery('#thankyou__modal').modal('toggle');
        thankyou();
    });


    function thankyou() {
        jQuery("#upgrade__modal").modal();
    }
});

function readURL(input) {

    if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function(e) {
            $('#profile').attr('src', e.target.result);
            $('#preview_mail_image').attr('srcmail_img', e.target.result);
        }

        reader.readAsDataURL(input.files[0]); // convert to base64 string
    }
}

function wreadURL(input) {

    if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function(e) {
            $('#profile').attr('src', e.target.result);
            $('#preview_mail_image').attr('wsrcmail_img', e.target.result);
        }

        reader.readAsDataURL(input.files[0]); // convert to base64 string
    }
}


//show
$("#input_7_1").change(function() {
    //$('#boo').html($("#input_7_1").val());

});
//types
$("input[name='input_2']").change(function() {
    // alert($("input[name='input_2']:checked").val());

});
//Company name
$("#input_7_3").keyup(function() {});
//website URL
$("#input_7_18").keyup(function() {

});
//Booth
$("#input_7_5").keyup(function() {
    $('#booth').html($("#input_7_5").val());


});
//Special Offer
$("#input_7_6").keyup(function() {
    $('#booth').html($("#input_7_6").val());
});
//workshop title
$("#input_7_7").keyup(function() {
    $('#workshop_title').html($("#input_7_7").val());
});
//Workshop time
$("#input_7_10").keyup(function() {
    $('#workshop_time').html($("#input_7_10").val());
});
//workshop location
$("#input_7_11").keyup(function() {
    $('#workshop_location').html($("#input_7_11").val());
});
//speaker Name
$("#input_7_12_3").keyup(function() {
    $('#spkr_name').html($("#input_7_12_3").val());
});
//Speaker Title
$("#input_7_14").keyup(function() {
    $('#spkr_jobtitle').html($("#input_7_14").val());
});
//Speaker Company
$("#input_7_15").keyup(function() {
    $('#spkr_company').html($("#input_7_15").val());
});


//$("#input_7_17").change(function() {
$(document).on('change', '#input_7_17', function() {
    var ext = $('#input_7_17').val().split('.').pop().toLowerCase();
    var picsize = (this.files[0].size);
    if ($.inArray(ext, ['gif', 'png', 'jpg']) == -1 || picsize > 2000000) {
        $('#preview_mail_image').attr('srcmail_img', "error");
    } else {
        // readURL(this);
        readURL(document.getElementById("input_7_17"));
        // console.log(this);
    }

});

$(document).on('change', '#input_7_19', function() {
    var ext = $('#input_7_19').val().split('.').pop().toLowerCase();
    var picsize = (this.files[0].size);

    if ($.inArray(ext, ['gif', 'png', 'jpg']) == -1 || picsize > 2000000) {
        $('#preview_mail_image').attr('srcmail_img', "error");
    } else {
        // readURL(this);
        wreadURL(document.getElementById("input_7_19"));
        // console.log(this);
    }
});

//   gform.addFilter('gform_pre_form_editor_save', 'save_form');
jQuery(document).on('gform_post_render', function(event, form_id, current_page) {

    if (form_id != 7) {
        return;
    }
    var show = $("#input_7_1").val();
    var types = $("input[name='input_2']:checked").val();
    var company_name_before = $("#input_7_3").val();
    var website_url = $("#input_7_20").val();
    var website_workshop_url = $("#input_7_26").val();
    var special_offer = $("#input_7_6").val();
    var workshop_title = $("#input_7_7").val();
    var workshop_time_hour = $("#input_7_27").val();
    var workshop_time_min = $("#input_7_28").val();
    var workshop_time_dn = $("#input_7_29").val();
    var workshop_time = workshop_time_hour + ':' + workshop_time_min + workshop_time_dn;
    var workshop_location = $("#input_7_11").val();
    var speaker_name_before = $("#input_7_12_3").val();
    var speaker_title = $("#input_7_14").val();
    var speaker_company_before = $("#input_7_15").val();
    var speaker_bio = $("#input_7_16").val();
    var booth = $("#input_7_5").val();

    if (types == "Exhibitor") {
        var company_name = company_name_before;
        var workshop_title = 'blank';
        var speaker_name = 'blank';
        var speaker_company = 'blank';
        var elogo = $("#preview_mail_image").attr("srcmail_img");
        if ($("#preview_mail_image").attr("wsrcmail_img") != undefined && $("#preview_mail_image").attr("wsrcmail_img") != 'error' && $("#preview_mail_image").attr("wsrcmail_img") != '') {
            var wimg = $("#preview_mail_image").attr("wsrcmail_img");
        } else {
            var wimg = '';
        }
    } else {
        var company_name = 'blank';
        var workshop_title = workshop_title;
        var speaker_name = speaker_name_before;
        var speaker_company = speaker_company_before;
        var wimg = $("#preview_mail_image").attr("wsrcmail_img");
        if ($("#preview_mail_image").attr("srcmail_img") != undefined && $("#preview_mail_image").attr("srcmail_img") != 'error' && $("#preview_mail_image").attr("srcmail_img") != '') {
            var elogo = $("#preview_mail_image").attr("srcmail_img");
        } else {
            var elogo = '';
        }
    }
    if (website_url == '') {
        var website = '';
    } else {
        if (ValidateURL(website_url)) {
            var website = website_url;

        } else {
            var website = "url";

        }
    }
    if (website_workshop_url == '') {
        var website_wrkshp = '';
    } else {
        if (ValidateURL(website_workshop_url)) {
            var website_wrkshp = website_workshop_url;

        } else {
            var website_wrkshp = "url";

        }
    }

    var image_src = elogo;
    var wimage_src = wimg;
    $(".btn-wrap #download-image, .btn-wrap #htmldownload,.btn-wrap #download-image1, .btn-wrap #htmldownload1").hide();
    //ajax

    if (form_id == 7 && show != '' && website != 'url' && website_wrkshp != 'url' && company_name != '' && workshop_title != '' && speaker_name != '' && speaker_company != '') {
        var displaydiv = $('#displaydiv');
        var ss_create_email_nonce = sbe_ajaxurl.ajax_nonce;
        var ajaxURL = sbe_ajaxurl.ajax_url;
        var data = {
            'action': 'create_email_preview',
            'security': ss_create_email_nonce,
            'show': show,
            'types': types,
            'company_name': company_name,
            'website': website,
            'website_wrkshp': website_wrkshp,
            'special_offer': special_offer,
            'workshop_title': workshop_title,
            'workshop_time': workshop_time,
            'workshop_location': workshop_location,
            'speaker_name': speaker_name,
            'speaker_title': speaker_title,
            'speaker_company': speaker_company,
            'speaker_bio': speaker_bio,
            'booth': booth,
            'image_src': image_src,
            'wimage_src': wimage_src,
            'form_id': form_id,

        };
        //$("#extensions_message_7_17").hide();
        $("#extensions_message_7_19").text("JPG, PNG & GIF Only. 2MB Max");
        $("#extensions_message_7_17").text("JPG, PNG & GIF Only. 2MB Max");
        $.ajax({
            url: ajaxURL,
            type: "POST",
            data: data
        }).done(function(response) {
            displaydiv.html(response);

            jQuery('.sponsors__type').each(function() {
                var requiredChilds = jQuery(this).find('li');
                if (requiredChilds.length == 0)
                    jQuery(this).remove();

            });

            var i = 1;

            $('.get-share-url').unbind('click').on('click', function(e) {
                e.preventDefault();
                var btn = $(this),
                    container = btn.parent();
                $.ajax({
                    url: ajaxURL,
                    type: "POST",
                    data: jQuery.extend(data, { 'action': 'get_share_url' })
                }).done(function(response) {
                    $('.share-url-input', container).html(response);
                    $('.share-url-input', container).attr('href', response);
                    $('.share-url-block', container).show();
                });
            });

            setTimeout(function() {
                displaydiv.find("[id^='dwn-social']").each(function(index, item) {
                    domtoimage.toJpeg(item, {
                        quality: 0.99
                    }).then(function(base64string) {

                        $.ajax({
                            url: getAdminUrl("/admin-ajax.php"),
                            type: "POST",
                            data: {
                                action: 'save-websitebadge',
                                base64: base64string
                            }
                        }).done(function(response) {
                            if (response.data.img_url) {
                                var share_class = '.social-share-img';
                                let img = document.createElement("img");
                                img.src = response.data.img_url;
                                img.classList.add('social-share-img');
                                img.id = 'social-share-img' + i;
                                item.after(img);
                                item.parentElement.querySelector("a.dwn-temp").href = response.data.img_url;

                                bgCover();

                                var footerHeight = [],
                                    badgeHeight = [],
                                    largeBadge, smallBadge, largeCalcHeight, smallCalcHeight;

                                smallBadge = $('#dwn-social1').parent().find('>.social-share-img');
                                largeBadge = $('#dwn-social3').parent().find('>.social-share-img');

                                function storeHeight(element, storeArr) {
                                    $(element).each(function(i, el) {
                                        storeArr.push($(el).outerHeight());
                                    });
                                }

                                storeHeight('.platform-card__footer', footerHeight);
                                storeHeight('.platform-card', badgeHeight);

                                console.log(footerHeight, badgeHeight);
                                console.log(largeBadge, smallBadge);

                                $(share_class).css({
                                    opacity: '0',
                                    position: 'absolute',
                                    top: '0',
                                    left: '15px',
                                    zIndex: '10',
                                    width: 'calc(100% - 30px)',
                                    right: '15px',
                                    // bottom: '' + footerHeight[i] + 'px',
                                    // height: 'calc('+ badgeHeight[i]+'px - '+ footerHeight[i]+'px)'
                                });

                                smallCalcHeight = badgeHeight[0] - footerHeight[0];
                                largeCalcHeight = badgeHeight[1] - footerHeight[1];

                                $(smallBadge).css({
                                    bottom: '' + footerHeight[0] + 'px',
                                    height: '' + smallCalcHeight + 'px'
                                });

                                $(largeBadge).css({
                                    bottom: '' + footerHeight[1] + 'px',
                                    height: '' + largeCalcHeight + 'px'
                                });

                                var socialIcons = $('#sti-box');

                                // show social icons on hover
                                $(share_class).on('mouseover', function() {
                                    var cardPosition = $(this).offset();

                                    socialIcons.css({
                                        top: '' + cardPosition.top + 'px',
                                        left: '' + cardPosition.left + 'px',
                                        display: 'block'
                                    });

                                    // $(share_class).css({
                                    // 	zIndex: '0'
                                    // });
                                });

                                // show icons on 
                                socialIcons.on('mouseover', function() {
                                    socialIcons.css({
                                        display: 'block'
                                    });
                                });

                                // hide social icons on mouseleave
                                $(share_class).on('mouseleave', function() {
                                    socialIcons.css({
                                        display: 'none'
                                    });
                                });

                                let link_data = document.getElementById('share-link');
                                $(share_class).attr('data-url', link_data);

                                //adding the title
                                let share_city = $(".city").attr("city");
                                var shareCityString = share_city + "'";
                                let share_city_title = 'Join me at ' + shareCityString + 's Biggest Networking Even';
                                $(share_class).attr('data-title', share_city_title);
                                console.log(shareCityString);

                                i++;
                            }
                        });
                    });

                });
            }, 2000);

            $("#website-badge, .btn-wrap #download-image, .btn-wrap #htmldownload,.btn-wrap #download-image1, .btn-wrap #htmldownload1").show();
            $(".btn-wrap .dwn-temp").hide();
            $("#extensions_message_7_19").text("JPG, PNG & GIF Only. 2MB Max");
            $("#extensions_message_7_17").text("JPG, PNG & GIF Only. 2MB Max");
            //$("#extensions_message_7_17").show();
            window.scroll({
                top: 900,
                behavior: 'smooth'
            });
            //displaydiv.show();
            $('#dwnld-wrap1').addClass('btn-wrap-btm');

        });

    }

});

function ValidateURL(urlToCheck) {
    // Below regular expression can validate input URL with or without http:// etc
    var pattern = new RegExp(/^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm);
    return pattern.test(urlToCheck);
}


$(document).ajaxComplete(function() {
    var current_active = $("#preview_email_wrap").attr("types");

    if (current_active != '') {
        if (current_active == 'Exhibitor') {
            var node = document.getElementById('exhibitior');
        }
        if (current_active == 'Workshop') {
            var node = document.getElementById('workshop');
        }
        if (node) {
            var content = node.outerHTML;
        }

        var downloadhtmllength = $("#htmldownload").length;
        if (downloadhtmllength > 0) {

            // var final_html = content.replace("'", "&quot;");
            // var final_preview = final_html.replace("#", "javascript:void(0)");
            document.getElementById("htmldownload").href = "data:text/html,<!DOCTYPE html><html><head><link rel='stylesheet' type='text/css' href='https://sbe.smartwebsitedesign.com/wp-content/themes/tsbe/style_email.css?ver=5.3.2'></head><body>".concat(content).concat("</body></html>");
            document.getElementById("htmldownload1").href = "data:text/html,<!DOCTYPE html><html><head><link rel='stylesheet' type='text/css' href='https://sbe.smartwebsitedesign.com/wp-content/themes/tsbe/style_email.css?ver=5.3.2'></head><body>".concat(content).concat("</body></html>");

        }
    }



});
jQuery(document).ready(function($) {
    $('#extensions_message_7_19').text('JPG, PNG & GIF Only. 2MB Max');
    $('#extensions_message_7_17').text('JPG, PNG & GIF Only. 2MB Max');
    $('#input_7_19').addClass('image-tooltip');
    $('#input_7_17').addClass('image-tooltip');
    jQuery(document).on('gform_confirmation_loaded', function(event, formId) {
        // code to be trigger when confirmation page is loaded
        if (formId == 8) {
            $('#form-title').hide();
        }
    });
});


jQuery(document).ready(function() {
    jQuery("#extensions_message_9_6").text("Accepted file types: JPG, PNG & PDF Only. 1MB Max");
});

jQuery(document).on('gform_post_render', function(event, form_id, current_page) {

    jQuery("#extensions_message_9_6").text("Accepted file types: JPG, PNG & PDF Only. 1MB Max");

});

var bgCover = function(context) {
    if (!context) context = jQuery('body');
    context.find('.bg-cover,[data-fix="image"]').each(function() {
        var wrap = jQuery(this),
            image = wrap.find('>img[src]');
        if (image.attr('src')) {
            if (wrap.data('fix') != 'image') {
                image.hide();
                wrap.css({
                    'background-image': 'url(\'' + image.attr('src') + '\')'
                });
            } else {
                wrap.find('.svg.img-fluid').css({
                    'background-image': 'url(\'' + image.attr('src') + '\')'
                });
            }
        }
    })
};

/***********************************
/***********************************
 * Load on scroll for blogs
 ***********************************/
jQuery(function ($) {
    if($('body').hasClass('page-template-tpl-business-card-exchange')) {
        var canBeLoaded = true,
            bottomOffset = 1800;
        var loader_cert = $(".ss-ajax-infinity-loader");
        var ajaxMessage = $("#ajaxMessage_blogs_posts");
    
        $(window).scroll(function () {
            var indust = jQuery(".ajax_cls.active").children().attr("industry");
            var industry = '';
            
            if (indust != undefined) {
                industry = indust;
                } else {
                industry = '';
                }
            var pageNum = $('#ss_page_num').val();
            var searchVal = $('#ss-exchange-search').val();
            
            var data = {
                        'action': 'display_business_card_exchange',
                        'category': industry,
                        'searchVal': searchVal ? searchVal : '',
                        'page': pageNum,
                        'isInfiniteScroll': true
                        };
            if (
                $(document).scrollTop() > $(document).height() - bottomOffset &&
                canBeLoaded == true
            ) {
                $.ajax({
                    url: sbe_ajaxurl.ajax_url,
                    data: data,
                    type: "POST",
                    beforeSend: function (xhr) {
                        loader_cert.show();
                        ajaxMessage.hide();
                        canBeLoaded = false;
                        console.log(pageNum);
                    },
                    success: function (response) {
                        var res = $.parseJSON(response);
                        if (res.results) {
                            $("#disp-content").append(res.results);
                            loader_cert.hide();
                            canBeLoaded = true;
                            $('#ss_page_num').attr("value",  (parseInt(pageNum)+1));
                            console.log(typeof pageNum);
                            
                            createPDFThumbnails();
                            bgCover();
                        } else {
                            loader_cert.hide();
                            ajaxMessage.show();
                            document.querySelector(".ss-no-results").innerHTML =
                                'No More Posts';
                            $(".ss-no-results").fadeOut(2000);
                        }
                    },
                });
            }
        });
    }
});

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

jQuery(document).on('click', '.industry-cat', function (e) {
  var $this = $(this);
  if($('.exchange-gallery__filter').hasClass('ss-no-selection')) {
    $('.exchange-gallery__filter').removeClass('ss-no-selection');
  }
  $("#disp-content").hide();
  $(".industry-cat").not($this).parent().removeClass("active");

  if ($(this).parent().hasClass('active')) {
    var industry = '';
    location.reload();
  } else {
    $(this).parent().addClass('active'); 
    var industry = $(this).attr('industry'); 
  } 
  jQuery('#ss_page_num').attr('value', 1);
  industry = (industry != '' || typeof industry !== 'undefined') ? industry : '';

  if(industry != '') {
          
    var words = industry.split(',');
    var str = '';
    $.each(words, function(index, item) {
        
      item = item.replace("_", " ");
      item = capitalizeFirstLetter(item);

      if(index == words.length-1 || words.length == 1)
        str += item;
      else
        str += item + ", ";
    });
  } else {
    str = "All Categories";
  }

  var elemt = (industry == "" || typeof industry !== 'undefined') ? " <span class='ss-unselect-txt'>Clear Selection</span>" : "";
  var fullStr = 'Searching In ' + str + '.' + elemt;
  jQuery('#ss-current-search-cat').html(fullStr);

  // Empty the search input field
  $('#ss-exchange-search').val('');

  var ajaxURL = sbe_ajaxurl.ajax_url;
  var data = {
    'action': 'display_business_card_exchange',
    'category': industry,
    'searchVal': '',
    'page': $('#ss_page_num').val()
  };
  $.ajax({
    url: ajaxURL,
    type: "POST",
    data: data,
    beforeSend: function (xhr) {
      $('.ss-loader-wrap').show();
    },
  }).done(function (response) {
    $('.ss-loader-wrap').hide();

    var res = $.parseJSON(response);
    $("#disp-content").html(res.results);
    
    $("#disp-content").show();
    createPDFThumbnails();
    bgCover();
    var header_height = document.getElementsByClassName('site-header').offsetHeight;
    $(window).scrollTop($('.exchange-gallery').offset().top - 90);
    $('.exchange-cont').matchHeight();

    jQuery('#ss_page_num').attr('value', 2);
  });
});
jQuery(document).on('click', '.ajax_paginate', function(e) {
    let page = $(this).attr('page');
    let indust = $(".ajax_cls.active").children().attr("industry");
    let industry = '';
    if (indust != undefined) {
        industry = indust;
    } else {
        industry = ''
    }
    let searchVal = $(this).val();
    let ajaxURL = sbe_ajaxurl.ajax_url;
    let data = {
        'action': 'display_business_card_exchange',
        'category': industry,
        'searchVal': searchVal ? searchVal : '',
        'page': page,
    }
    $.ajax({
        url: ajaxURL,
        type: "POST",
        data: data,
        beforeSend: function (xhr) {
            $('.ss-loader-wrap').show();
        }
    }).done(function(response) {
        $('.ss-loader-wrap').hide();

        var res = $.parseJSON(response);
        $("#disp-content").html(res.results);
        
        $("#disp-content").show();
        createPDFThumbnails();
        bgCover();
    });
});
jQuery(document).on('gform_confirmation_loaded', function(event, formId) {
    // code to be trigger when confirmation page is loaded
    if (formId == 9) {
        $('.mandatory').hide();
    }
});

//image size exceed message
$(document).on('change', '#input_9_6', function() {
    var ext = $('#input_9_6').val().split('.').pop().toLowerCase();
    var picsize = (this.files[0].size);
    if (picsize > 1000000) {
        // if ($.inArray(ext, ['pdf', 'png', 'jpg']) == -1 || picsize > 1000000) {
        alert("File exceed the maximum size.Please upload the file with maximum 1 MB size!");
    }

});

//flag modal
//flag changed
jQuery(document).on('change', '.abuse_flag', function() {

    var flag_content = jQuery('#flag-textarea').val();
    var abuse_id = jQuery(this).val();
    if (jQuery(this).is(":checked")) {
        jQuery('#flag-send').attr('abuse_id', abuse_id);
        jQuery('#abuse-modal').modal('show');

        var abuse = 1;
    } else {
        var abuse = 0;
        let ajaxURL = sbe_ajaxurl.ajax_url;
        $(this).prop('checked', true);
        return;
    }
});
jQuery(document).on('click', '#flag-send', function() {
    var flag_content = jQuery('#flag-textarea').val();
    var abuse_id = jQuery('#flag-send').attr('abuse_id');

    let ajaxURL = sbe_ajaxurl.ajax_url;
    //ajax
    jQuery.ajax({
        type: "POST",
        url: ajaxURL,
        dataType: 'json',
        data: {
            action: 'exchange_flag_action',
            abuse_id: abuse_id,
            abuse: 1,
            abuse_content: flag_content,
        }
    }).done(function(msg) {
        jQuery('#abuse-modal').modal('hide');
        jQuery('#abuse-confirm-modal').modal('show');
    });
});
jQuery(document).on('click', '.close-flag', function() {
    var temp = jQuery('#flag-send').attr('abuse_id');
    var current_cls = '.abuse_check_' + temp;
    jQuery(current_cls).prop('checked', false);
});